import {getValidProp} from '../../../../utils/cleanValidateStringPropValue';
import libConstants from '../constants';

const SIZE_SMALL = 'small';
const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

const TYPE_BUTTON = 'button';
const TYPE_RESET = 'reset';
const TYPE_SUBMIT = 'submit';

export const ccButtonConstants = Object.freeze({
  SIZE_SMALL: SIZE_SMALL,
  SIZE_MEDIUM: SIZE_MEDIUM,
  SIZE_LARGE: SIZE_LARGE,
  SIZES: [SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE],
  SIZE_DEFAULT: SIZE_MEDIUM,

  TYPE_BUTTON: TYPE_BUTTON,
  TYPE_RESET: TYPE_RESET,
  TYPE_SUBMIT: TYPE_SUBMIT,
  TYPES: [TYPE_BUTTON, TYPE_RESET, TYPE_SUBMIT],
  TYPE_DEFAULT: TYPE_BUTTON,
  TITLE_DEFAULT: 'Button',
});

export const ccButtonPropsDefaults = Object.freeze({
  type: ccButtonConstants.TYPE_DEFAULT,
  size: ccButtonConstants.SIZE_DEFAULT,
  clickFn: null,
  clickFnArgs: undefined,
  title: ccButtonConstants.TITLE_DEFAULT,
  isDisabled: false,
});

export function getValidType(propsType, componentName) {
  return getValidProp(propsType, 'type', ccButtonConstants.TYPE_DEFAULT, ccButtonConstants.TYPES, componentName, libConstants.LIB_DEBUG_LOGGER);
}

export function getValidSize(propsSize, componentName) {
  return getValidProp(propsSize, 'size', ccButtonConstants.SIZE_DEFAULT, ccButtonConstants.SIZES, componentName, libConstants.LIB_DEBUG_LOGGER);
}
